import Request from '../../utils/request';
import { MethodType } from '../../utils/types';
/**
 * Implementa la clase PingCmsPage
 */
class PingCmsPage {
  /**
   */
  constructor({ context }) {
    /**
     * Crea el body necesario para enviar a CustoMetrics
     */
    function createBodyMessage() {
      try {
        let requestBody = {};
        let cdUrl = '';
        cdUrl =
          window &&
          window.location &&
          window.location.host &&
          window.location.pathname
            ? window.location.host + window.location.pathname
            : 'no_recuperable';

        requestBody = {
          cdSource: 'PingCmsPages',
          cdTimeStamp: new Date().toISOString(),
          cdType: 'CMS-PAGE',
          cdUrl,
          ctzId: '',
          ctzPageId: '',
          ctzTemplateId: '',
          phCode: '',
          posCode: '',
          status: '',
          uiGAClientId:
            (context && context.clientIDs && context.clientIDs.ga) || '',
          wbPageId:
            (context && context.clientIDs && context.clientIDs.pageId) || '',
          wbSessionId:
            (context && context.clientIDs && context.clientIDs.sessId) || '',
          webCode: '',
          wsContext: PROJECT_ID || null,
          versionJS: VERSION_JS || null,
          cdSegment: (context && context.pageSegment) || 'no_def',
        };

        return requestBody;
      } catch (err) {
        return null;
      }
    }

    /**
     * Envía la comunicacion con el servicio de CustoMetrics
     * @param {any} errorInfo (opcional) Información asociada al evento que se está sondando
     * @param {string} stackTrace (opcional) La traza del error
     * @param {Severity} severidad (opcional) severidad de la sonda
     * @return {undefined}
     */
    function sendInfoToCtzMetricsData() {
      try {
        const endPoint =
          'https://europe-west1-mov-prod10.cloudfunctions.net/export-customizer-data-metrics';
        const headers = {
          timeout: 6000,
          'Content-Type': 'application/json',
        };

        const requestBody = createBodyMessage();
        if (requestBody) {
          const request = new Request({
            method: MethodType.POST,
            endpoint: endPoint,
            data: requestBody,
            headers,
          });

          request.makeRequest();
        }
      } catch (e) {
        console.log(e);
      }
    }

    // eslint-disable-next-line func-names
    this.sendPingCmsPage = function () {
      sendInfoToCtzMetricsData();
    };
  }
}

export default PingCmsPage;
